<template>
  <div class="enter_form">
    <el-form label-position="top">
      <el-form-item label="店铺绑定手机">
        <el-input v-model="applyObj.phone" placeholder="店铺绑定手机号即为店铺的登陆账号名"></el-input>
      </el-form-item>
      <el-form-item label="验证码" class="code">
        <el-input v-model="applyObj.code" placeholder="请输入短信验证码"></el-input>
        <el-button @click="getCode" :disabled="verifyStatus">{{verifyText}}</el-button>
      </el-form-item>
    </el-form>
    <el-row class="btn-submit">
      <el-button @click="next" type="danger">下一步，选择店铺类型</el-button>
    </el-row>
  </div>
</template>
<script>
export default {
  model: {
    prop: "form"
  },
  props: {
    form: Object
  },
  data() {
    return {
      applyObj: {},
      verifyStatus: false,
      verifyText: "获取验证码"
    };
  },
  destroyed() {
    this.timer && clearInterval(this.timer);
  },
  methods: {
    next() {
      this.form.step = 1;
      this.$emit("update:form", this.form);
    },
    getCode() {
      this.verifyStatus = true;
      let time = 120;
      this.verifyText = time + "s";
      this.timer = setInterval(() => {
        if (time == 1) {
          this.verifyText = "重新获取";
          this.verifyStatus = false;
          clearInterval(this.timer);
          return;
        }
        this.verifyText = --time + "s";
      }, 1000);

      this.$confirm("当前手机号还不是销巴会员，请先申请会员", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          // 去注册
          this.form.type = "regist";
          this.$emit("update:form", this.form);
        })
        .catch(() => {
          this.verifyStatus = false;
          this.verifyText = "获取验证码";
          this.timer && clearInterval(this.timer);
        });
    }
  }
};
</script>
<style lang="less" scoped>
.enter_form {
  width: 417px;
  .code {
    .el-input{
      width: 273px;
      border-radius: 4px;
    }
    .el-button {
      width: 128px;
      border-radius: 4px;
      font-size: 16px;
      height: 41px;
      margin-left: 16px;

      &:not([disabled]) {
        color: #e60616;
        border: 1px solid #e60616;
      }
    }
  }
  .btn-submit {
    .el-button--danger:not([disabled]) {
      background-color: #e60616;
    }
  }
}
</style>